module.exports = __webpack_public_path__ + "img/160.4df53bb4.png";